<div class="shell">
  @if (showBack || title) {
    <div class="header">
      @if (showBack) {
        <lib-button icon-only (click)="back.emit()">
          <mat-icon>arrow_back</mat-icon>
        </lib-button>
      }
      @if (title) {
        <div class="title">
          {{ title }}
        </div>
      }
    </div>
  }

  <div class="content" #panelContent>
    <ng-content></ng-content>
  </div>
</div>
